$(document).ready(function () {


    document.querySelectorAll('[data-slider-config]').forEach(slider => {
      const config = JSON.parse(slider.dataset.sliderConfig);

      if (!$(slider).hasClass('slick-initialized')) {
        $(slider).slick(config);
      }
    });

});

 $(document).on("click", ".el-play-button", function (e) {
     var video = jQuery(this).parents('.el-video-wrapper').find('video');
 if (jQuery(this).hasClass("active")) {
    jQuery(this).parents('.el-video-wrapper').removeClass('active');
     jQuery(this).removeClass('active');
 video.trigger('pause');
 } else {
 video.trigger('play');
   jQuery(this).parents('.el-video-wrapper').addClass('active');
     jQuery(this).addClass('active');
 }
 });



 
jQuery(document).ready(function(){
if(navigator.userAgent.indexOf('Mac') > 0) {
jQuery('body').addClass('mac-os');
} else {
jQuery('body').addClass('window-os');
}
});

$(window).on('scroll', function () {
  let scrollTop = $(this).scrollTop();

  if (scrollTop > 30) {
    $('body').addClass('remove_transparent');
  } else {
    $('body').removeClass('remove_transparent');
  }
});



$(document).on("click", ".el-question", function (e) {
  if (jQuery(this).hasClass("active")) {
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  } else {
    jQuery('.el-question').removeClass('active');
    jQuery('.el-question').next().slideUp();
    jQuery(this).toggleClass('active');
    jQuery(this).next().slideToggle();
  }
});


$(document).on("click", "a[href='/#faq']", function (e) {
  const target = document.querySelector('.el-faq');

  if (target) {
    e.preventDefault();
    target.scrollIntoView({
      behavior: 'smooth'
    });
  }
  // else: do nothing → browser follows the link normally
});
$(document).on("click", "a[href='#reviews']", function (e) {
  e.preventDefault();
  document.querySelector('#reviews').scrollIntoView({
    behavior: 'smooth'
  })
});

$(document).on("click", ".el-mobile-menu-button", function (e) {
    $('.el-drawer-menu').addClass('active');
    $('.el-drawer-menu-bg').show();
    $('body').addClass('el-overflow-hidden');
});
$(document).on("click", ".el-mobile-menu-close", function (e) {
    $('.el-drawer-menu').removeClass('active');
    $('.el-drawer-menu-bg').hide();
    $('body').removeClass('el-overflow-hidden');
});

$(document).on("click", ".el-drawer-menu-bg", function (e) {
    $('.el-drawer-menu').removeClass('active');
    $('.el-drawer-menu-bg').hide();
    $('body').removeClass('el-overflow-hidden');
});



$(document).on("click", ".el-element-variant", function(e) {
$(this).parents('.el-product').find('.el-element-variant').removeClass('el-active');
$(this).addClass('el-active');
var variant_id = $(this).attr('variant_id');
$(this).parents('.el-product').find('.el-variant-trigger').hide().removeClass('el-active');
$(this).parents('.el-product').find('.el-variant-trigger[variant_id="'+variant_id+'"]').show().addClass('el-active');
$(this).parents('.el-product').find('.el-checkout-button').attr('variant_id',variant_id);
});

$(document).on("click", ".el-element-option", function(e) {
$(this).parents('.el-product').find('.el-element-option').removeClass('el-active');
$(this).addClass('el-active');
var quantity = $(this).attr('quantity');
$(this).parents('.el-product').find('.el-quantity-trigger').hide().removeClass('el-active');
$(this).parents('.el-product').find('.el-quantity-trigger[quantity="'+quantity+'"]').show().addClass('el-active');
$(this).parents('.el-product').find('.el-checkout-button').attr('quantity',quantity);
});











$(document).on("click", ".el-cart-button", function (e) {
   window.kachingCartApi.openCart();
});
$(document).on("click", ".el-mobile-cart-close, .el-drawer-cart-bg, a[href='#close_cart']", function (e) {
  e.preventDefault();
    $('.el-cart-drawer').removeClass('active');
    $('.el-drawer-cart-bg').hide();
    $('body').removeClass('el-overflow-hidden');
});








$(document).on("click", "a[href='#more']", function (e) {
  e.preventDefault();
 $('.el-pdp-review2-list1-item:nth-child(3)~.el-pdp-review2-list1-item').slideDown();
 $('.el-pdp-review2-links:has(a[href="#more"])').hide();
 $('.el-pdp-review2-links:has(a[href="#less"])').show();
});



$(document).on("click", "a[href='#less']", function (e) {
  e.preventDefault();
 $('.el-pdp-review2-list1-item:nth-child(3)~.el-pdp-review2-list1-item').slideUp();
 $('.el-pdp-review2-links:has(a[href="#less"])').hide();
 $('.el-pdp-review2-links:has(a[href="#more"])').show();
});




$(document).on("click", ".el-pdp-insoles-list-item3 .el-element-text ul li", function (e) {
  e.preventDefault();
 $(this).parents('ul').find('li').removeClass('el-active');
 $(this).addClass('el-active');
});


$(document).on("click", ".el-pdp-insoles-list1 .el-pdp-insoles-list-item3 .el-element-text ul li", function (e) {
$('.el-pdp-insoles-list-item1 .el-element-text ul').each(function(){
  $(this).find('li:not(.el-active)').eq(0).addClass('el-active');
});
$('.el-pdp-insoles-list1').removeClass('el-active');
$('.el-pdp-insoles-list2').addClass('el-active');
});
$(document).on("click", ".el-pdp-insoles-list2 .el-pdp-insoles-list-item3 .el-element-text ul li", function (e) {
$('.el-pdp-insoles-list-item1 .el-element-text ul').each(function(){
  $(this).find('li:not(.el-active)').eq(0).addClass('el-active');
});
$('.el-pdp-insoles-list2').removeClass('el-active');
$('.el-pdp-insoles-list3').addClass('el-active');
});

$(document).on("click", ".el-pdp-insoles-list3 .el-pdp-insoles-list-item3 .el-element-text ul li", function (e) {
$('.el-pdp-insoles-list-item1 .el-element-text ul').each(function(){
  $(this).find('li:not(.el-active)').eq(0).addClass('el-active');
});
$('.el-pdp-insoles-list3').removeClass('el-active');
$('.el-pdp-insoles-list4').addClass('el-active');
});


$(document).on("click", ".el-pdp-insoles-list3 .el-pdp-insoles-list-item3 .el-svg", function (e) {
$('.el-pdp-insoles-list-item1 .el-element-text ul').each(function(){
  $(this).find('li.el-active').last().removeClass('el-active');
});
$('.el-pdp-insoles-list3').removeClass('el-active');
$('.el-pdp-insoles-list2').addClass('el-active');
});

$(document).on("click", ".el-pdp-insoles-list2 .el-pdp-insoles-list-item3 .el-svg", function (e) {
$('.el-pdp-insoles-list-item1 .el-element-text ul').each(function(){
  $(this).find('li.el-active').last().removeClass('el-active');
});
$('.el-pdp-insoles-list2').removeClass('el-active');
$('.el-pdp-insoles-list1').addClass('el-active');
});



$(document).on("click", ".el-pdp-insoles-list4 .el-pdp-insoles-list-item3 .el-svg", function (e) {
$('.el-pdp-insoles-list4').removeClass('el-active');
$('.el-pdp-insoles-list3').addClass('el-active');
});















function updateCartCount() {
  return fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {


      var count = 0;

      cart.items.forEach(function (item) {
          count += item.quantity;
      });
      $('.el-cart-count').text(count);
      if (count > 0) {
        $('.el-cart-count').show();
      } else {
        $('.el-cart-count').hide();
      }

      return count;
    })
    .catch(err => console.error('Cart count error:', err));
}





  $(document).on("click", '.el-pdp-insoles-list4-text1 .el-element-text a', function (e) {
  e.preventDefault();

  var $btn2 = $(this);
  var $btn = $('.el-checkout-button');

  // prevent multiple clicks
  if ($btn2.hasClass('el-loading')) return;

  $btn2.addClass('el-loading');

  var items = [];
  // main product
  var variant_id = $btn.attr('variant_id');
  var selling_plan = $btn.attr('selling_plan');
  var quantity = $btn.attr('quantity');
  var item = {
    id: parseInt(variant_id),
    quantity: quantity
  };

  // add selling plan if exists
  if (selling_plan) {
    item.selling_plan = parseInt(selling_plan);
  }
  var weight = $('.el-pdp-insoles-list2 .el-pdp-insoles-list-item3 .el-element-text ul li.el-active').text();
  var age = $('.el-pdp-insoles-list3 .el-pdp-insoles-list-item3 .el-element-text ul li.el-active').text();
  var properties = {
  "Weight": weight,
  "Age":age
};
if (properties) {
  item.properties = properties;
}
  items.push(item);
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify({
      items: items
    }),
    dataType: 'json',
    contentType: 'application/json',

    success: function () {

    },

    complete: function () {
      setTimeout(function () {
        $btn2.removeClass('el-loading');
    updateCartCount();
      }, 500);
    }
  });

});





$(document).on("click", ".el-pdp-insoles-list1 .el-pdp-insoles-list-item3 .el-element-text ul li", function (e) {
var index = $(this).index();
$('.el-element-variant').eq(index).trigger('click');
});


$(document).on("click", ".el-pdp-pdt-small-heading1 .el-element-richtext em", function (e) {
$('.el-popup').addClass('el-active');
});
$(document).on("click", ".el-close-popup", function (e) {
$('.el-popup').removeClass('el-active');
});